module.exports = ".listado-caracteristicas-container {\n  padding: 0px 16px; }\n\n.tr-wrap {\n  flex-wrap: wrap;\n  max-width: 590px; }\n"